import { SignInButton as AuthKitSignInButton } from "@farcaster/auth-kit";
import { track } from "@vercel/analytics";
import React from "react";

import { Button } from "../Button";

type Props = React.ComponentProps<typeof AuthKitSignInButton>;

export function FarcasterLoginButton(props: Props) {
  function login() {
    const signinButton = document.querySelector<HTMLButtonElement>(
      `#authkit-button-wrapper button`,
    );
    if (!signinButton) {
      throw new Error("Sign in button not found");
    }
    signinButton.click();
    track("login_button_clicked");
  }

  return (
    <>
      <Button className="w-full" onClick={login}>
        log in with Farcaster
      </Button>
      <div
        className="hidden"
        id="authkit-button-wrapper"
        data-testid="authkit-button-wrapper"
      >
        <AuthKitSignInButton
          {...props}
          nonce={async () => {
            const response = await fetch("/api/siwe/nonce");
            const { nonce } = await response.json();
            return nonce;
          }}
        />
      </div>
    </>
  );
}
